// Module
var code = "<administration-accounts-equipment-grid title=\"$ctrl.title\"></administration-accounts-equipment-grid>\n\n<tabs-navigation identifier=\"app.administration.accounts\"\n                 state=\"app.administration.accounts.headOfficesEquipment\">\n</tabs-navigation>\n";
// Exports
module.exports = code;